<form [formGroup]="reabrirForm">
    <h2 mat-dialog-title>Reabrir tarea</h2>
    <mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-label>Fecha m&aacute;xima</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="maxDate" [min]="minDate">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Comentario</mat-label>
            <textarea matInput formControlName="comentario"></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close cdkFocusInitial>Cancelar</button>
        <button type="submit" mat-flat-button (click)="close()" [disabled]="!reabrirForm.valid || fetchingReabrirTarea">
            <div class="btn-login-content">
                @if (fetchingReabrirTarea) {
                <mat-spinner diameter="20" color="warn"></mat-spinner>
                }@else{
                <p>Aceptar</p>
                }
            </div>
        </button>
    </mat-dialog-actions>
</form>